import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { CONTACT } from "../../content/site";
import { Reveal } from "./motion";

export const Greeting = () => (
  <Reveal delay={0.1} className="relative mt-10 max-w-xl rounded-[28px] border border-[#E2DDD0] bg-[#FBF9F4] p-7 sm:p-9" >
    <div data-testid="about-greeting">
      <Quote className="h-7 w-7 text-[#C86D51]" aria-hidden="true" />
      <p className="mt-4 text-base leading-relaxed text-[#1B281E] md:text-lg">
        Hallo und schön, dass Sie hier sind! Ich bin Jonas und kümmere mich bei GRÜNWIRBEL persönlich um Ihre Anfrage.
        Einen Garten pflege ich so, wie ich ihn selbst gern hätte: ordentlich, mit Ruhe und mit einem Blick für die kleinen Dinge.
        Erzählen Sie mir einfach, was Ihr Garten braucht – ich freue mich auf Ihre Nachricht.
      </p>
      <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }} className="mt-6">
        <motion.p
          data-testid="about-greeting-signature"
          className="font-script inline-block pr-2 text-4xl text-[#1E5631] sm:text-5xl"
          variants={{ hidden: { clipPath: "inset(0 100% 0 0)" }, show: { clipPath: "inset(0 0% 0 0)" } }}
          transition={{ duration: 1.6, ease: [0.65, 0, 0.35, 1], delay: 0.4 }}
        >
          {CONTACT.owner}
        </motion.p>
      </motion.div>
      <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#8C6D53]">Ihr Ansprechpartner · {CONTACT.area}</p>
    </div>
  </Reveal>
);
